import {
  FETCH_ADMIN_ANALYTICS_REQUEST,
  FETCH_ADMIN_ANALYTICS_SUCCESS,
  FETCH_ADMIN_ANALYTICS_FAILURE,
  FETCH_QUESTION_ANALYTICS_REQUEST,
  FETCH_QUESTION_ANALYTICS_SUCCESS,
  FETCH_QUESTION_ANALYTICS_FAILURE,
  FETCH_STUDENT_DETAILS_REQUEST,
  FETCH_STUDENT_DETAILS_SUCCESS,
  FETCH_STUDENT_DETAILS_FAILURE,
  CLEAR_ADMIN_ANALYTICS
} from './AdminAnalyticsTypes';

const initialState = {
  // Student progress data
  students: [],
  totalStudents: 0,

  // Overall statistics
  overallStats: {
    totalTests: 0,
    completedTests: 0,
    averageScore: 0,
    totalQuestionsAnswered: 0,
    totalCorrect: 0,
    totalIncorrect: 0,
    totalOmitted: 0,
    averageTimePerQuestion: 0
  },

  // Question-level analytics
  questionAnalytics: [],

  // Subject performance aggregates
  subjectStats: [],

  // Individual student details (when viewing specific student)
  selectedStudent: null,

  // Loading states
  loading: false,
  questionLoading: false,
  studentLoading: false,

  // Error state
  error: null
};

const adminAnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADMIN_ANALYTICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_ADMIN_ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        students: action.payload.students,
        totalStudents: action.payload.totalStudents,
        overallStats: action.payload.overallStats,
        subjectStats: action.payload.subjectStats || [],
        error: null
      };

    case FETCH_ADMIN_ANALYTICS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case FETCH_QUESTION_ANALYTICS_REQUEST:
      return {
        ...state,
        questionLoading: true,
        error: null
      };

    case FETCH_QUESTION_ANALYTICS_SUCCESS:
      return {
        ...state,
        questionLoading: false,
        questionAnalytics: action.payload,
        error: null
      };

    case FETCH_QUESTION_ANALYTICS_FAILURE:
      return {
        ...state,
        questionLoading: false,
        error: action.payload
      };

    case FETCH_STUDENT_DETAILS_REQUEST:
      return {
        ...state,
        studentLoading: true,
        error: null
      };

    case FETCH_STUDENT_DETAILS_SUCCESS:
      return {
        ...state,
        studentLoading: false,
        selectedStudent: action.payload,
        error: null
      };

    case FETCH_STUDENT_DETAILS_FAILURE:
      return {
        ...state,
        studentLoading: false,
        error: action.payload
      };

    case CLEAR_ADMIN_ANALYTICS:
      return initialState;

    default:
      return state;
  }
};

export default adminAnalyticsReducer;
